
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M11.2 1.167A2.336 2.336 0 0113.533 3.5v7a2.336 2.336 0 01-2.333 2.333h-7A2.336 2.336 0 011.867 10.5v-7A2.336 2.336 0 014.2 1.167h7zM11.2 0h-7A3.5 3.5 0 00.7 3.5v7A3.5 3.5 0 004.2 14h7a3.5 3.5 0 003.5-3.5v-7A3.5 3.5 0 0011.2 0z"}}),_c('path',{attrs:{"d":"M10.617 7.583H4.783a.584.584 0 010-1.166h5.834a.583.583 0 110 1.166zm0-2.916H4.783a.584.584 0 010-1.167h5.834a.584.584 0 110 1.167zm0 5.833H4.783a.584.584 0 110-1.167h5.834a.584.584 0 110 1.167z"}})])])
          )
        }
      }
    